import React from "react";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section
      className="cta-area4 space"
      data-overlay="title"
      data-opacity="9"
      data-bg-src="/assets/img/update2/bg/cta_bg_1.jpg"
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-6 mb-5 mb-lg-0">
            <div className="title-area text-center mb-0 text-lg-start">
              <span className="sub-title8 mb-20">
                <img
                  src="/assets/img/update2/theme-img/title_left.svg"
                  alt="shape"
                />
                Al Jurf Pest Control LLC.
              </span>
              <h2 className="sec-title text-white">
                Book a Free Inspection Today{" "}
                <span className="text-theme">with Al Jurf</span>
              </h2>
              <p className="text-white mt-3">
                From deep cleaning to pest control, we’re available 24/7 to help
                you maintain a safer, healthier space.
              </p>
            </div>
          </div>

          {/* Right Buttons */}
          <div className="col-lg-6">
            <div className="cta-group justify-content-lg-end justify-content-center">
              <Link to="/contact" className="th-btn style3">
                Request a Call
                <i className="fa-regular fa-arrow-right ms-2"></i>
              </Link>
              <Link to="/service" className="th-btn style4">
                Explore Services
                <i className="fa-regular fa-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
